import store from "../../store/store"
import { UserHub } from "../hubs/users"

export const usersHub = new UserHub(store)
